import { GitCompare, X } from 'lucide-react';
import { useCompare } from '@/contexts/CompareContext';

const CompareBar = () => {
  const { compareItems, removeFromCompare, setIsCompareOpen } = useCompare();

  if (compareItems.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-secondary text-secondary-foreground p-4 shadow-lg animate-slide-in-up">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <GitCompare className="w-5 h-5 text-primary" />
            <span className="font-semibold">Compare ({compareItems.length}/4)</span>
          </div>
          
          <div className="flex items-center gap-2">
            {compareItems.map((product) => (
              <div
                key={product.id}
                className="relative w-12 h-12 rounded-lg overflow-hidden border-2 border-primary/30 group"
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
                <button
                  onClick={() => removeFromCompare(product.id)}
                  className="absolute inset-0 bg-secondary/80 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
        </div>

        <button
          onClick={() => setIsCompareOpen(true)}
          className="btn-rise bg-primary text-primary-foreground px-6 py-2 rounded-full font-semibold flex items-center gap-2"
        >
          <GitCompare className="w-4 h-4" />
          Compare Now
        </button>
      </div>
    </div>
  );
};

export default CompareBar;
